import { GOOGLE_AUTH_ROUTE, SUBSCRIPTION_PRICE, SUBSCRIPTION_TRIAL_DAYS } from '../../constants'

const Closing = () => (
    <section className="closing" id="pricing">
        <div className="gt-container" data-reveal>
            <h2 className="closing__h">Try one goal.</h2>
            <p>
                General Task is {SUBSCRIPTION_PRICE}. Free for {SUBSCRIPTION_TRIAL_DAYS} days. No card at signup.
            </p>
            <div className="hero__ctas">
                <a className="btn btn--primary" href={`/${GOOGLE_AUTH_ROUTE}`} target="_self">
                    Start free trial
                </a>
                <a className="btn btn--secondary" href="#pricing" target="_self">
                    See pricing
                </a>
            </div>
        </div>
    </section>
)

export default Closing
